import useMatchPlay from "@hooks/game/use-match-play";
import React, { createContext, ReactNode, useContext } from "react";

type MatchPlayContextType = ReturnType<typeof useMatchPlay>;

const MatchPlayContext = createContext<MatchPlayContextType | undefined>(undefined);

export const MatchPlayProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const matchPlayData = useMatchPlay();

  return <MatchPlayContext.Provider value={matchPlayData}>{children}</MatchPlayContext.Provider>;
};

export const useMatchPlayContext = () => {
  const context = useContext(MatchPlayContext);
  if (context === undefined) {
    throw new Error("useMatchPlayContext must be used within a MatchPlayProvider");
  }
  return context;
};
